export const commonNavLinks = [
    { label: 'ראשי', href: '/' },
    { label: 'קטגוריות מוצרים', href: '/categories' },
    { label: 'גלריית פרויקטים', href: '/projects' },
    { label: 'צור קשר', href: '/contact' },
];
